// src/modules/app-views/invoices/pages/Init/components/tableColumns/items/itemCofinsColumn.jsx
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import { Typography } from 'antd';
import financialService from 'services/financialService';
import { resolveItemFontSize } from './index';

const { Text } = Typography;

// *******************************************************************************
// COLUMN FUNCTION
// *******************************************************************************

// Renders the COFINS (social contribution on revenue) value column for item subtables.
function itemCofinsColumn(options = {}) {
  const { size, ..._ } = options;
  const fontSize = resolveItemFontSize(size, 10);
  return {
    title: 'COFINS',
    dataIndex: ['tax', 'cofins', 'value'],
    width: 70,
    align: 'right',
    sorter: (a, b) => {
      const aVal = a?.tax?.cofins?.value || a?.cofins || 0;
      const bVal = b?.tax?.cofins?.value || b?.cofins || 0;
      return aVal - bVal;
    },
    render: (_, item) => {
      const cofins = item?.tax?.cofins?.value || item?.cofins;
      if (!cofins) {
        return (
          <Text style={{ fontSize }} type="secondary">
            —
          </Text>
        );
      }
      return (
        <Text style={{ fontSize }} type="secondary">
          {financialService.formatCurrency(cofins)}
        </Text>
      );
    },
  };
}

export default itemCofinsColumn;
